/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {

  // $('body').on('click','.navlink--search',function(event){
  //   document.getElementById("searchDetails").open = true;
  // });
  
  $(".footerTitle").click(function(){
      $(this).parent(".customFooterInner").toggleClass("open"); 
  });
  $('.rewardPopupClick').on('click', function(){
    $('.rewardsModal').show();
    $('.rewardsModal_Main').show();
  });
  $('.rewardsModalClose').on('click', function(){
    $('.rewardsModal').hide();
    $('.rewardsModal_Main').hide();
  });

  $('.farePricingClick').on('click', function(){
    $('.farePricingModal').show();
    $('.farePricingModal_Main').show();
  });
  $('.farePricingModalClose').on('click', function(){
    $('.farePricingModal').hide();
    $('.farePricingModal_Main').hide();
  });

  $('body').on('click', '.sizeCartPDP', function(){
    $('.sizeChart--popup noscript[data-rg-size-chart]').each(function(){
      var template = document.createElement('template');
      template.innerHTML = this.children.length ? this.innerHTML : this.textContent;
      this.replaceWith(template.content);
    });
    $('.sizeChart--popup').show();
  });
  $('.modal_close').on('click', function(){
    $('.sizeChart--popup').hide();
  });

  $('.custom_bundlePopupClick').on('click', function(){
    $('.custom_bundleModal').show();
    $('.custom_bundleModal_Main').show();
  });
  $('.custom_bundleModalClose').on('click', function(){
    $('.custom_bundleModal').hide();
    $('.custom_bundleModal_Main').hide();
  });

  $('.product__slide.hide').html('');
  
  var pendingMediaPosters = new Set();
  var mediaVisibilityFrame;
  var mediaObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) startVisibleMedia(entry.target);
    });
  }) : null;

  function startVisibleMedia(poster) {
    var media = poster.closest('deferred-media, product-model');
    if (!poster.isConnected || !media || media.hasAttribute('loaded')) {
      pendingMediaPosters.delete(poster);
      if (mediaObserver) mediaObserver.unobserve(poster);
      return;
    }
    var slide = poster.closest('.product__slide');
    if (slide && (slide.classList.contains('hide') ||
        (slide.closest('.flickity-enabled') && !slide.classList.contains('is-selected')))) return;
    if (poster.closest('[hidden], [aria-hidden="true"]') || !poster.getClientRects().length) return;
    var rect = poster.getBoundingClientRect();
    if (rect.bottom <= 0 || rect.right <= 0 || rect.top >= window.innerHeight || rect.left >= window.innerWidth) return;
    var style = window.getComputedStyle(poster);
    if (style.visibility === 'hidden' || style.display === 'none') return;

    // Keep autoplay while avoiding automatic focus changes from a simulated click.
    if (typeof media.loadContent === 'function') media.loadContent(false);
    else poster.click();
    if (media.hasAttribute('loaded')) {
      pendingMediaPosters.delete(poster);
      if (mediaObserver) mediaObserver.unobserve(poster);
    }
  }

  function observeDeferredMedia() {
    // Discard replaced variant-gallery nodes before observing their replacements.
    pendingMediaPosters.forEach(function(poster) {
      if (!poster.isConnected) {
        pendingMediaPosters.delete(poster);
        if (mediaObserver) mediaObserver.unobserve(poster);
      }
    });
    document.querySelectorAll('.deferred-media__poster').forEach(function(poster) {
      var media = poster.closest('deferred-media, product-model');
      if (!media || media.hasAttribute('loaded')) return;
      if (!pendingMediaPosters.has(poster)) {
        pendingMediaPosters.add(poster);
        if (mediaObserver) mediaObserver.observe(poster);
      }
      startVisibleMedia(poster);
    });
  }

  function checkPendingMedia() {
    if (mediaVisibilityFrame || !pendingMediaPosters.size) return;
    mediaVisibilityFrame = requestAnimationFrame(function() {
      mediaVisibilityFrame = null;
      pendingMediaPosters.forEach(startVisibleMedia);
    });
  }

  // Native carousel media events continue to work. These cover visible stacked
  // media, tab reveals and browsers without IntersectionObserver as well.
  document.addEventListener('theme:tab:change', checkPendingMedia);
  window.addEventListener('resize', checkPendingMedia, {passive: true});
  if (!mediaObserver) window.addEventListener('scroll', checkPendingMedia, {passive: true});
  setTimeout(observeDeferredMedia, 6500);
  // document.addEventListener('DOMContentLoaded', function() {
  //     setTimeout(function() { 
  //         $('.deferred-media__poster-button').click();
  //     }, 4500);
  // });

  var variantPageRequest;
  var variantPageTimer;
  var variantMediaTimer;
  var variantPageVersion = 0;

  $(".main_product_buttons input").change(function() {
    var requestVersion = ++variantPageVersion;
    var mediaReadyAt = Date.now() + 2500;
    clearTimeout(variantPageTimer);
    clearTimeout(variantMediaTimer);
    if (variantPageRequest) variantPageRequest.abort();

    // Let the existing variant handler update this preview page's URL first.
    variantPageTimer = setTimeout(function() {
      variantPageRequest = $.ajax({url: window.location.href, dataType: 'html'});
      variantPageRequest.done(function(response) {
        if (requestVersion !== variantPageVersion) return;
        // Match the previous .load(selector) script-stripping behavior, but parse
        // the page once and keep both server-filtered fragment selectors intact.
        var fragments = $('<div>').append($.parseHTML(response));
        var sku = fragments.find('.productSku_text');
        var slides = fragments.find('.product__slide');
        if (sku.length) $('.productSku').html(sku);
        if (slides.length) $('.product__slides').html(slides);
        variantMediaTimer = setTimeout(function() {
          if (requestVersion === variantPageVersion) observeDeferredMedia();
        }, Math.max(0, mediaReadyAt - Date.now()));
      });
      variantPageRequest.always(function() {
        if (requestVersion === variantPageVersion) variantPageRequest = null;
      });
    }, 0);
  });

  // $(".main_product_buttons_page input").change(function() {
  //   $(".productSku").load(top.location.href + " .productSku_text");
  //   $(".product__slides").load(top.location.href + " .product__slide");
    
  //   var pdpVaraintSku = $(this).data('varaint_sku');
  //   var altWith_varaintSku = 'altVariant-'+pdpVaraintSku;
    
  //   alert(altWith_varaintSku);
    
  //   setTimeout(function() { 
        
  //       $('.product__slide').addClass('hide');
  //       $('.altVariant-'+pdpVaraintSku).removeClass('hide');
  //   }, 1500);
    
  // });

  
  
  $( document ).ready(function() {

    $(".buy_option_expand").click(function(){
      var $ans = $(this).next(".buy_option_expand_desc");
      var $current = $(this);
      $ans.slideToggle(500);
      $current.toggleClass("open");
      $(".buy_option_expand_desc").not($ans).slideUp(500);
      $(".buy_option_expand").not($current).removeClass("open");
    });
    $('.rte-tab section .expand-collpase:first-child .buy_option_expand').trigger('click');

    
    $('body').on('change','.chainSelect',function(event){
      var optionVal = $(this).val();
      if(optionVal != ""){
        $('.chainSelect').attr('name', 'items[1][id]');
      }else{
        $('.chainSelect').attr('name', '');
      }
      
    });
  });

  //You May Also Like JS Start
  $('[data-cart-toggle]').click(function(event) {
    if(window.cart.hasItemsInCart()){
      $('.drawer__inner').addClass('drawer__inner_width');
      $('.main_P_R').fadeIn();
    }else{
      $('.drawer__inner').removeClass('drawer__inner_width');
      $('.main_P_R').fadeOut();
    }
  });

  $('[data-cart-drawer-close]').click(function(event) {
    $('.drawer__inner').removeClass('drawer__inner_width');
    $('.main_P_R').fadeOut();
  });
  $('.productAddTOCart').click(function(event) {
    // window.cart.updateProgress = function() {    
      if(window.cart.hasItemsInCart()){
        $('.drawer__inner').addClass('drawer__inner_width');
        $('.main_P_R').fadeIn();
        // $("#shopify-section-recommendations-products").load(top.location.href + " .product-recommendations");
      }else{
        $('.drawer__inner').removeClass('drawer__inner_width');
        $('.main_P_R').fadeOut();
      }
    // };
  });

  // Free Shipping bar update on click
  // $('.productAddTOCart').on('click', function(){
  //   if(window.cart.getCart()){
  //     console.log('Manny Sahu');
  //     $(".drawer__message").load(top.location.href + " .drawer__message");
  //   }
  // });
  
  //You May Also Like JS End
  
  $('.addToCartForm_CTL').on('submit', function(event) {
    // alert('hi');
    event.preventDefault(); // prevent default form submission
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: $(this).serialize(),
      dataType: 'json',
      success: function() {
        	window.cart.getCart();
            
        },
      error: function() {
        // Do something on error (e.g. show an error message)
      }
    });
  });

  $('.addToCartForm_custom_bundle').on('submit', function(event) {
    // alert('hi');
    event.preventDefault(); // prevent default form submission
    var formURL = $(this).serialize();
    var hiddenID = getUrlParameter(formURL, 'product-id');
    $.ajax(
        {
            url: '/recommendations/products?section_id=recommendations-products&product_id='+hiddenID+'&limit=8&intent=related',
            type: 'GET',
            dataType: 'html'
        }
    ).done(function(data){
        
        var newData = $(data).find('.product-recommendations');
        $('.recommendationsProducts').html(data);
        $('.drawer__inner').addClass('drawer__inner_width');
        $('.main_P_R').fadeIn();
    });
    
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: $(this).serialize(),
      dataType: 'json',
      success: function() {
        	window.cart.getCart();
            $('.custom_bundleModal').hide();
            $('.custom_bundleModal_Main').hide();
            
        },
      error: function() {
        // Do something on error (e.g. show an error message)
      }
    });
  });

  $('.addToCartForm_custom_bundle_ATC').on('submit', function(event) {
    // alert('hi');
    event.preventDefault(); // prevent default form submission
    var formURL = $(this).serialize();
    var hiddenID = getUrlParameter(formURL, 'product-id');
    $.ajax(
        {
            url: '/recommendations/products?section_id=recommendations-products&product_id='+hiddenID+'&limit=8&intent=related',
            type: 'GET',
            dataType: 'html'
        }
    ).done(function(data){
        
        var newData = $(data).find('.product-recommendations');
        $('.recommendationsProducts').html(data);
        $('.drawer__inner').addClass('drawer__inner_width');
        $('.main_P_R').fadeIn();
    });
    
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: $(this).serialize(),
      dataType: 'json',
      success: function() {
        	window.cart.getCart();
            
        },
      error: function() {
        // Do something on error (e.g. show an error message)
      }
    });
  });
  


  var getUrlParameter = function getUrlParameter(pageURL, sParam) {
    var sPageURL = pageURL,
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};

  
  
  $('body').on('submit','.addToCartForm_PLP',function(event){
    // alert('hi');
    event.preventDefault(); // prevent default form submission
    var formURL = $(this).serialize();
    var hiddenID = getUrlParameter(formURL, 'product-id');
    $.ajax(
        {
            url: '/recommendations/products?section_id=recommendations-products&product_id='+hiddenID+'&limit=8&intent=related',
            type: 'GET',
            dataType: 'html'
        }
    ).done(function(data){
        
        var newData = $(data).find('.product-recommendations');
        $('.recommendationsProducts').html(data);
        $('.drawer__inner').addClass('drawer__inner_width');
        $('.main_P_R').fadeIn();
    });
    
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: $(this).serialize(),
      dataType: 'json',
      success: function() {
        	window.cart.getCart();
            
        },
      error: function() {
        // Do something on error (e.g. show an error message)
      }
    });
  });

  document.body.addEventListener('click', function(event) {
    const button = event.target.closest('.quick-add__button_new');
    if (!button) return;

  // $('body').on('click','.quick-add__button_new',function(event){
    // alert('hi');
    var hidden_product_ID = $(button).data('pid');
    // alert(hidden_product_ID);
    $.ajax(
        {
            url: '/recommendations/products?section_id=recommendations-products&product_id='+hidden_product_ID+'&limit=8&intent=related',
            type: 'GET',
            dataType: 'html'
        }
    ).done(function(data){
        
        var newData = $(data).find('.product-recommendations');
        $('.recommendationsProducts').html(data);
        $('.drawer__inner').addClass('drawer__inner_width');
        $('.main_P_R').fadeIn();
    });
  }, true);

  $('.productAddTOCart').on('click', function() {
    var hidden_product_ID = $('.hiddenProductID').val();
    // alert(hidden_product_ID);
    $.ajax(
        {
            url: '/recommendations/products?section_id=recommendations-products&product_id='+hidden_product_ID+'&limit=8&intent=related',
            type: 'GET',
            dataType: 'html'
        }
    ).done(function(data){
        
        var newData = $(data).find('.product-recommendations');
        $('.recommendationsProducts').html(data);
        $('.drawer__inner').addClass('drawer__inner_width');
        $('.main_P_R').fadeIn();
    });
  });
  
  $('.navlink--cart').on('click', function() {
    var last_product_ID = $('.last_productID').val();
    // alert(last_product_ID);
    $.ajax(
        {
            url: '/recommendations/products?section_id=recommendations-products&product_id='+last_product_ID+'&limit=8&intent=related',
            type: 'GET',
            dataType: 'html'
        }
    ).done(function(data){
        
        var newData = $(data).find('.product-recommendations');
        $('.recommendationsProducts').html(data);
        $('.drawer__inner').addClass('drawer__inner_width');
        $('.main_P_R').fadeIn();
    });
  
  });

  $('body').on('submit','.addToCartForm_drawer_tab',function(event){
    // alert('hi');
    $('.drawer__inner__new').addClass('loader');
    event.preventDefault(); // prevent default form submission
    var formURL = $(this).serialize();
    var hiddenID = getUrlParameter(formURL, 'product-id');
    $.ajax(
        {
            url: '/recommendations/products?section_id=recommendations-products&product_id='+hiddenID+'&limit=8&intent=related',
            type: 'GET',
            dataType: 'html'
        }
    ).done(function(data){
        
        var newData = $(data).find('.product-recommendations');
        $('.recommendationsProducts').html(data);
        $('.drawer__inner').addClass('drawer__inner_width');
        $('.main_P_R').fadeIn();
    });
    
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: $(this).serialize(),
      dataType: 'json',
      success: function() {
        	window.cart.getCart();
            $('.drawer__inner__new').removeClass('loader');
            $(".drawer__body").animate({ scrollTop: 0 }, "slow");
        },
      error: function() {
        // Do something on error (e.g. show an error message)
      }
    });
  });

  //Landing page addon script start
  $('body').on('submit','.addToCartForm_lp_addon',function(event){
      // alert('hi'); 
      event.preventDefault(); // prevent default form submission
      var formURL = $(this).serialize();
      var hiddenID = getUrlParameter(formURL, 'product-id');
      // alert(formURL);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: $(this).serialize(),
        dataType: 'json',
        success: function() {
          	document.location.href = '/cart/checkout';
          },
        error: function(xhr, textStatus, error) {
          var err = eval("(" + xhr.responseText + ")");
          $('.errorMessage_lp_addon').html("<p>"+err.message+"</p>");
          // Do something on error (e.g. show an error message)
        }
      });
    });
  //Landing page addon script End
  
  // Select Chain PDP Script Start
    function addCheckedToCheckedRadio() {
      $('.product-details__crosssell-option input[type="radio"]').each(function() {
        $(this).toggleClass('checked', this.checked);
      });
    }
  
    // Bind click event to allow deselecting radio buttons
    // $('.product-details__crosssell-option input[type="radio"]').click(function(event) {
    $('body').on('click','.product-details__crosssell-option input[type="radio"]',function(event){
      if ($(this).hasClass('checked')) {
        this.checked = false;
        $('.product-details__crosssell-selection').text("Nothing Select");
        $('.product-details__crosssell-price').text("");
        $('.selectedChainOption').attr('name', '');
        $('.selectedChainOption').val('');
      }else{
        var dataName = $(this).data("name");
        var dataPrice = $(this).data("display-price");
        var dataValue = $(this).data("key");
        $('.product-details__crosssell-selection').text(dataName);
        $('.product-details__crosssell-price').text(dataPrice);
        $('.selectedChainOption').attr('name', 'items[1][id]');
        $('.selectedChainOption').val(dataValue);
      }
      addCheckedToCheckedRadio();
    });
  // Select Chain PDP Script End

  //Cart Free Product Add Script Start

  $('body').on('click','.cartOfferFreeProduct',function(event){
    // alert($(this).data('variant_id'));
    event.preventDefault();
    
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: $(this).data('variant_id')
      },
      dataType: 'json',
      success: function() {
        	window.cart.getCart();
            
        },
      error: function() {
        // Do something on error (e.g. show an error message)
      }
    });
  });
  $('body').on('click','.rebuy-button',function(event){
    alert('added to cart');
    setTimeout(function() { 
        window.cart.getCart();
    }, 1500);
  });
  

  //Cart Free Product Add Script End

  $('form#free_ring_sizer-form').on('submit', function(event){
      //debugger;
      event.preventDefault();
      var postUrl = $(this).attr('action');
      var postData = $(this).serialize();
      alert('done');

      //console.log(postData); check what your form posts

      $.ajax({
          type: "POST",
          url: postUrl,
          data: postData,
          dataType: "json",
          success: function(data) {
              console.log('Account created')
               //redirect to somewhere
               window.location.replace("/some-url");
          },
          error: function() {
              console.log('error handling here');
          }
      });
  });


  $('.payIcons .lastIcon').on('click', function(){
      $('.moreIcon').removeClass('hide');
      $('.payIcons .lastIcon').addClass('hide');
      $('.payIcons').removeClass('allIcons');
  });

  // get size value in product page for product ID: 14943027724663 Start
   $( document ).ready(function() {
    var productID = $('.index-product').data('product-id');
    if(productID == 14943027724663){
      function get_size_from_carat(carat_value){
        var new_size_value = '';
        if(carat_value == '0.25'){
          new_size_value = '3.2mm'
        }else if((carat_value == '0.30') || (carat_value == '0.3')){
          new_size_value = '3.4mm'
        }else if((carat_value == '0.50') || (carat_value == '0.5')){
          new_size_value = '4mm'
        }else if((carat_value == '1') || (carat_value == '1.0')){
          new_size_value = '5mm'
        }
        return new_size_value;
      }
      
      var get_selected_variant_val = $('.radio__buttons .Carat.radio__button input:checked~label .variantTitle span').text();
      if(get_selected_variant_val != ''){
        // $('.productSizeWithCarot .radio__legend__value').text(get_size_from_carat(get_selected_variant_val))
        $('.productSizeWithCarot').html(
          `<fieldset>
              <div class="radio__fieldset">
                <legend class="radio__legend" style="margin: 0;">
                  <span class="radio__legend__label">
                    <span class="radio__legend__option-name">Size</span>
                    <input type="hidden" name="attributes[Size]" value="`+get_size_from_carat(get_selected_variant_val)+`">
                    <small class="radio__legend__value">`+get_size_from_carat(get_selected_variant_val)+`</small>
                  </span>
                </legend>
              </div>
            </fieldset>`
        )
      }
      $('.radio__buttons .radio__button.Carat input').on('click', function(){
        var carat_swtach_val = $(this).val()
        var get_size_value = get_size_from_carat(carat_swtach_val)
        $('.productSizeWithCarot .radio__legend__value').text(get_size_value)
      })
    }
    
  });

  // Rewards Point text change according to swatches START
  jQuery(document).ready(function($) {
    // On radio button change
    $(".radio__buttons input[type='radio']").on("change", function() {
      // Get current product price text
      let priceText = $("[data-product-price]").text().trim();

      // Clean currency & convert to number
      let price = parseFloat(priceText.replace(/[^\d\.]/g, ''));

      if (!isNaN(price)) {
        // Calculate 5% value
        let fivePercent = price * 0.05;

        // Update rewardsVal span
        $(".rewardsVal").text(fivePercent.toFixed(2));
      }

      // Variant change and show text for Pre-Order Start
      let swatchText = $(this).val().trim();
      // console.log(swatchText);
      if(swatchText == "Sun and Moon" || swatchText == "Majestic Dragon" || swatchText == "Dual Dragon" || swatchText == "Elephant" || swatchText == "Rose"){
        $(".variant_preOrderMessage").show();
      } else {
        $(".variant_preOrderMessage").hide();
      }
      // Variant change and show text for Pre-Order End
    });

    // Trigger once on page load (in case first radio is already selected)
    $(".radio__buttons input[type='radio']:checked").trigger("change");
  });

  $(document).ready(function () {
  const $iframe = $('iframe#tidio-chat-iframe');

      // Set default width
      $iframe.css('width', '100px !important');

      // Toggle width on click
      $iframe.on('click', function () {
        if ($iframe.width() === 100) {
          $iframe.css('width', '100% !important');
        } else {
          $iframe.css('width', '100px !important');
        }
      });
    });

  $(document).ready(function(){
      $('.ringSizer_tab').click(function(){
          var tab_id = $(this).data('tab');
          $('.ringSizer_tab').removeClass('active');
          $(this).addClass('active');
          $('.ringSizer_tab-content').removeClass('active');
          $('#' + tab_id).addClass('active');
      });
  });

  $(document).ready(function(){
      const $items = $('#delivery-returns-faq .delivery-returns__accordion-item');
      $items.each(function(){
        const $item = $(this);
        const $header = $item.find('.delivery-returns__accordion-header');
        const $panel = $item.find('.delivery-returns__accordion-panel');
        if($item.hasClass('active')) { $panel.show(); }
        $header.on('click', function(){
          const isActive = $item.hasClass('active');
          $items.removeClass('active').find('.delivery-returns__accordion-panel').slideUp(160);
          $items.find('.delivery-returns__accordion-icon').text('+');
          if(!isActive){
            $item.addClass('active');
            $panel.stop(true,true).slideDown(160);
            $item.find('.delivery-returns__accordion-icon').text('–');
          }
        });
      });

      $('.faq__accordion').each(function() {
        const $accordion = $(this);
        const $faq_items = $accordion.find('.faq__accordion-item');

        $faq_items.each(function() {
          const $faq_item = $(this);
          const $faq_header = $faq_item.find('.faq__accordion-header');
          const $faq_panel = $faq_item.find('.faq__accordion-panel');

          // Show panel if item is pre-set active
          if ($faq_item.hasClass('active')) {
            $faq_panel.show();
            $faq_item.find('.faq__accordion-icon').text('–');
          }

          $faq_header.on('click', function() {
            const isActive = $faq_item.hasClass('active');

            // Close all items inside the same accordion group
            $faq_items.removeClass('active').find('.faq__accordion-panel').slideUp(160);
            $faq_items.find('.faq__accordion-icon').text('+');

            // Open clicked one if it was not already active
            if (!isActive) {
              $faq_item.addClass('active');
              $faq_panel.stop(true, true).slideDown(160);
              $faq_item.find('.faq__accordion-icon').text('–');
            }
          });
        });
      });

  });

  // Rewards Point text change according to swatches END

  // get size value in product page for product ID: 14943027724663 End

  // if(window.cart.updateCart()){
  //   console.log('There are now items in the cart.');
  // }  

  // Start Hide Cart Drawer Tabs when cart is empty
  
    // function fetchCartCount(callback) {
    //   fetch('/cart.js')
    //   .then(response => response.json())
    //   .then(data => {
    //     console.log(data.item_count)
    //     if(data.item_count > 0){
    //       $('.cart_bottomInformation').show();
    //     }else{
    //       $('.cart_bottomInformation').hide();
    //     }
    //   });
    // }
    
    // document.addEventListener('click', handleUserInteraction);
    // document.addEventListener('keypress', handleUserInteraction);
      
    // function handleUserInteraction () {
    //   setTimeout(fetchCartCount, 800);
    // }
    
    // fetchCartCount();
  
  // End Hide Cart Drawer Tabs when cart is empty
  
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.

  // website right click and save or keyboard shortcut disable Start
  // Disable right-click on images
  // Disable right-click only on images
  // Disable right-click only on product images
  // Disable right-click ONLY on product images
  // Disable right-click ONLY on images (site-wide)
  document.addEventListener('contextmenu', function (e) {
    // Check if the right-clicked element is an image
    if (
      e.target.tagName.toLowerCase() === 'img' ||
      e.target.closest('.product__photo') ||
      e.target.closest('.product-item__image')
    ) {
      e.preventDefault();
    }
  }, false);

  // Disable dragging of ALL images (product, banner, logo, etc.)
  document.querySelectorAll('img').forEach(img => {
    img.setAttribute('draggable', false);
  });

  // Optional: Disable developer shortcuts
  document.addEventListener('keydown', function (e) {
    // Ctrl+Shift+I or Ctrl+Shift+J (Inspect tools)
    if (e.ctrlKey && e.shiftKey && (e.key.toLowerCase() === 'i' || e.key.toLowerCase() === 'j')) {
      e.preventDefault();
      return false;
    }

    // Ctrl+U (View Source) or Ctrl+S (Save)
    if (e.ctrlKey && (e.key.toLowerCase() === 'u' || e.key.toLowerCase() === 's')) {
      e.preventDefault();
      return false;
    }

    // Optional: F12 (Developer Tools)
    if (e.key === 'F12') {
      e.preventDefault();
      return false;
    }
  });
  // Variant text change according to Design Swatch START
  // jQuery(document).ready(function($) {
  //   // On radio button change
  //   $(".radio__buttons input[type='radio']").on("change", function() {
  //     // Get current product text
      
      
  //   });

  //   // Trigger once on page load (in case first radio is already selected)
  //   $(".radio__buttons input[type='radio']:checked").trigger("change");
  // });
  // Variant text change according to Design Swatch END

  // website right click and save or keyboard shortcut disable End

})();
